export default {
  data: () => ({
    translations: {
      title: {
        el: 'Eπίπεδα',
        en: 'Tiers',
        it: 'Livelli',
      },
      question: {
        el: 'Θέλετε να ορίσετε επίπεδα για το πρόγραμμα επιβράβευσης σας;',
        en: 'Do you want to set tiers for your loyalty program?',
        it: 'Volete stabilire dei livelli per il vostro programma fedeltà?',
      },
      yes: {
        el: 'Ναι',
        en: 'Yes',
        it: 'Sì',
      },
      no: {
        el: 'Όχι',
        en: 'No',
        it: 'No',
      },
      modeDesrciption_points: {
        el: 'Επιλέξτε αν τα επίπεδα θα καθορίζονται σύμφωνα με τους διαθέσιμους πόντους ή το συνολικό ποσό που έχει δαπανήσει o πελάτης στην εταιρεία σας:',
        en: "Select if tiers will be set according to customer's available points or customer's total amount spent at your company:",
        it: "Stabilite se i livelli saranno impostati in base ai punti disponibili del cliente o all'importo totale speso dal cliente presso la vostra azienda:",
      },
      modeDesrciption_cashback: {
        el: 'Επιλέξτε αν τα επίπεδα θα καθορίζονται σύμφωνα με το διαθέσιμο cashback ή το συνολικό ποσό που έχει δαπανήσει o πελάτης στην εταιρεία σας:',
        en: "Select if tiers will be set according to customer's available cashback or customer's total amount spent at your company:",
        it: "Stabilite se i livelli saranno impostati in base al cashback disponibile del cliente o all'importo totale speso dal cliente presso la vostra azienda:",
      },
      available_points: {
        el: 'Διαθέσιμοι πόντοι',
        en: 'Available points',
        it: 'Punti disponibili',
      },
      available_cashback: {
        el: 'Διαθέσιμο cashback',
        en: 'Available cashback',
        it: 'Cashback disponibile',
      },
      totalAmount: {
        el: 'Συνολικό ποσό',
        en: 'Τotal amount',
        it: 'Importo totale',
      },
      save: {
        el: 'Αποθήκευση',
        en: 'Save',
        it: 'Salva',
      },
      expireDescription: {
        el: 'Επιλέξτε λειτουργία αντιστοίχισης επιπέδων.',
        en: 'Do you want to set expiry days for each tier?',
        it: 'Specificare se i livelli saranno impostati con il numero di giorni di scadenza.',
      },
      yesExpire_points: {
        el: '<b>Λειτουργία επιπέδων με χρόνο λήξης:</b> Αφού ο πελάτης φτάσει σε ένα νέο επίπεδο, θα διατηρήσει τα προνόμια αυτού του επιπέδου για ορισμένο χρονικό διάστημα, ακόμη και αν οι πόντοι του μειωθούν κάτω από το σημείο έναρξης του επιπέδου. Το χρονικό αυτό διάστημα ορίζεται κατά την δημιουργία του κάθε επιπέδου.',
        en: '<b>Expiration tier mode:</b> After customer reaches a new tier, he will keep the privileges of this tier, even if his points get lower than the tier beginning point. This time interval is set when each tier is created.',
        it: '<b>Modalità di scadenza del livello:</b> Dopo aver raggiunto un nuovo livello, il cliente manterrà i privilegi di questo livello, anche se i suoi punti diventano inferiori al punto iniziale del livello. Questo intervallo di tempo viene impostato al momento della creazione di ciascun livello.',
      },
      yesExpire_cashback: {
        el: '<b>Λειτουργία επιπέδων με χρόνο λήξης:</b> Αφού ο πελάτης φτάσει σε ένα νέο επίπεδο, θα διατηρήσει τα προνόμια αυτού του επιπέδου για ορισμένο χρονικό διάστημα, ακόμη και αν το cashback του μειωθούν κάτω από το σημείο έναρξης του επιπέδου. Το χρονικό αυτό διάστημα ορίζεται κατά την δημιουργία του κάθε επιπέδου.',
        en: '<b>Expiration tier mode:</b> After customer reaches a new tier, he will keep the privileges of this tier, even if his cashback get lower than the tier beginning cashback. This time interval is set when each tier is created.',
        it: '<b>Modalità di scadenza del livello:</b> Dopo aver raggiunto un nuovo livello, il cliente manterrà i privilegi di questo livello, anche se i suoi cashback diventano inferiori al cashback iniziale del livello. Questo intervallo di tempo viene impostato al momento della creazione di ciascun livello.',
      },
      noExpire: {
        el: '<b>Live λειτουργία επιπέδων:</b> Οι πελάτες θα αντιστοιχίζονται δυναμικά σε κάθε επίπεδο, χαμηλότερο ή υψηλότερο, μετά την υποβολή μιας συναλλαγής.',
        en: '<b>Live tier mode:</b> Customers will be dynamically assigned to each level, lower or higher, after a transaction is submitted. ',
        it: "<b>Modalità Live Tier:</b> Ι clienti vengono assegnati dinamicamente a ciascun livello, inferiore o superiore, dopo l'invio di una transazione. il cliente sarà assegnato al livello superiore o inferiore, nel momento in cui una transazione viene presentata.",
      },
      confirmSaveMsg: {
        el: 'Με αυτή την ενέργεια θα διαγραφούν όλα τα επίπεδα που έχουν δημιουργηθεί. Είστε σίγουροι ότι θέλετε να προχωρήσετε;',
        en: 'This action will delete all created tiers. Are you sure you want to proceed?',
        it: 'Questa azione eliminerà tutti i livelli creati. Siete sicuri di voler procedere?',
      },
    },
  }),
};
